import {createApp} from 'vue'
import Store from 'store'
import options from './SpotFiftyFifty.options'

const component = createApp(options).use(Store)

const el = '.nlx-component--spot-fifty-fifty'
const DOM = document.querySelector(el)

if(DOM){
    const template = DOM.outerHTML
    options.template = template

    component.mount(el)
}

